import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { BookingService } from 'app/services/booking.service';

@Component({
  selector: 'guest-selection',
  templateUrl: './guest-selection.component.html',
})

export class GuestSelectionComponent implements OnInit {
  public allowedAge = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ];
  public guestData = {
    rooms: [{
      Adults: 1,
      Child: [], // { Age: number, Bed: number, valid: null, availableBedTypes: any }
    }],
  };
  public guestSelector = {
    adultUnit: {
      plural: "",
      single: "",
    },
    childAgePluralLabel: "",
    childAgeReqdError: "",
    childAgeSingularLabel: "",
    childAgeSelectLabel: "",
    childBedTypes: {
      'crib': { text: "", value: 1 },
      'extra-bed': { text: "", value: 2 },
      'parents-bed': { text: "", value: 0 },
    },
    childSelectAgeLabel: "",
    childSelectBedtypeLabel: "",
    childUnit: {
      plural: "",
      single: "",
    },
    doneButtonLabel: "",
    label: "",
    rewardsNightError: "",
    voucherError: "",
    roomCountLabel: "",
    roomLabel: "",
    roomPluralLabel: "",
    bookingInnerWidgetguestsLabel: ""
  };
  public guestText: string;
  public isOpen: boolean = false;
  public previousTimeout: number;
  public rootEle: Element;
  public roomCount = 1;
  public valid = false;
  public validated = false;
  closeEventListner: any;

  @ViewChild('guest') public guestEle: any;
  @ViewChild('guestInput') public guestInputEle: any;

  @Input("redemption") redemption: boolean = false;
  @Input("voucherBookingCode") voucher: boolean = false;
  @Output() changed: any = new EventEmitter<{}>();
  @Output() dataChanged: any = new EventEmitter<{}>();

  constructor(private bookingService: BookingService) { }

  ngOnInit(): void {
    /** For Angular SSR bypass complete JS to resolve window and document related issues  */
    if (typeof window == 'undefined' || typeof document == 'undefined')
      return;
  }

  ngAfterViewInit(): void {
    this.guestSelector = window['Scandic'].bookingWidgetLabels.guestSelector || this.guestSelector;
    this.rootEle = this.guestEle.nativeElement.parentElement;
    this.valid = true;
    this.validated = false;

    if (this.bookingService.getSearchData('guest')) {
      this.guestData = this.bookingService.getSearchData('guest');
    }
    const currentUrl = decodeURIComponent(window.location.href.toLowerCase());
    if (currentUrl.indexOf("hotel=") != -1 || currentUrl.indexOf("?city=") != -1) {
      this.guestData.rooms = window['Scandic'].bookingWidgetData.rooms;
    }
    if (this.guestData && this.guestData.rooms) {
      this.roomCount = this.guestData && this.guestData.rooms ? this.guestData.rooms.length : 1;
      this.updateGuestSelectorView();
    }
    this.updateChildBedTypes();

    this.updateText("init");
    this.changed.emit({ valid: true, roomCount: this.roomCount });
    if (navigator.userAgent.indexOf("iPhone OS") != -1) {
      setTimeout(function() {
        document.querySelectorAll(".child-info select").forEach(function (item) {
          if (item["id"].indexOf("age") != -1) {
            item["value"] = item.querySelector("option[selected]")["value"];
          }
        });
      }, 1500);
    }
  }

  getTotalGuestsData(rooms: any): any {
    let totalAdults = 0, totalChildren = 0;
    rooms.forEach((room) => {
      totalAdults += room.Adults;
      totalChildren += room.Child.length;
    });
    return { Adults: totalAdults, Children: totalChildren, };
  }

  updateText(inInit?: string): void {
    let totalAdult = 0;
    let childCount = 0;
    this.guestData.rooms.forEach((room) => {
      totalAdult += room.Adults;
      childCount += room.Child.length;
    });
    this.guestText = totalAdult.toString()  + " " +
      (<any>totalAdult == 1 ? this.guestSelector.adultUnit.single : this.guestSelector.adultUnit.plural);

    if (childCount > 0) {
      this.guestText += ", " + childCount.toString() + " " +
        (childCount == 1 ? this.guestSelector.childUnit.single : this.guestSelector.childUnit.plural);
    }

    if (this.roomCount > 1)
      this.guestText = this.guestText + ", " + this.roomCount.toString() + " " + this.guestSelector.roomPluralLabel;

    if (typeof(document) != "undefined" && document.getElementById("summary-guest-details")) {
      document.getElementById("summary-guest-details").innerHTML = this.guestText;
    }

    if (!inInit) {
      this.dataChanged.emit();
    }
  }

  updateRooms(): void {
    if (this.guestData.rooms.length == this.roomCount)
      return;

    while (this.guestData.rooms.length != this.roomCount) {
      if (this.guestData.rooms.length < this.roomCount) {
        this.guestData.rooms.push({
          Adults: 1,
          Child: []
        });
      } else {
        this.guestData.rooms.pop();
      }
    }

    this.updateText();
    this.updateGuestSelectorView();
  }

  updateGuestSelectorView(): void {
    this.rootEle.classList.remove('left--50');
    this.rootEle.classList.remove('left--100');
    if (window.innerWidth > 767) {
      if (this.guestData.rooms.length == 2) {
        this.rootEle.classList.add('left--50');
        this.rootEle.classList.remove('left--100');
      } else if (this.guestData.rooms.length > 2) {
        this.rootEle.classList.add('left--100');
      }
    }
  }

  updateGuestCount(event: any, roomIndex: number): void {
    if (event.type == 'child') {
      if (this.guestData.rooms[roomIndex].Child.length == event.value)
        return;

      if (this.guestData.rooms[roomIndex].Child.length < event.value) {
        this.guestData.rooms[roomIndex].Child.push({
          Age: -1,
          Bed: -1,
          valid: null,
          availableBedTypes: null,
        });
      } else {
        this.guestData.rooms[roomIndex].Child.pop();
      }
    } else {
      this.guestData.rooms[roomIndex]["Adults"] = event.value;
    }
    this.updateText();
    this.updateChildBedTypes();
  }

  updateChildInfo(i: number, j: number, key: string, e: Event): void {
    this.guestData.rooms[i].Child[j][key] = e.target['value'];
    if (this.guestData.rooms[i].Child[j][key]) {
      this.guestData.rooms[i].Child[j].valid = true;
    }
    this.updateText();
    this.updateChildBedTypes();
  }

  updateChildBedTypes(): any {
    this.guestData.rooms.forEach((room) => {
      let availableParentsBed = room.Adults;
      let childIndices = [];
      room.Child.forEach((child, index) => {
        if (availableParentsBed > 0 && child.Bed == this.guestSelector.childBedTypes["parents-bed"].value) {
          availableParentsBed = availableParentsBed - 1;
          childIndices.push(index);
        }
      });
      room.Child.forEach((child, index) => {
        let types = [];
        let selected = false;
        if (child.Age <= 5 && (availableParentsBed > 0 || childIndices.indexOf(index) != -1 )) {
          types.push(this.guestSelector.childBedTypes["parents-bed"]);
          if (child.Bed == this.guestSelector.childBedTypes["parents-bed"].value) {
            selected = true;
          }
        }
        if (child.Age <= 2) {
          types.push(this.guestSelector.childBedTypes["crib"]);
          if (child.Bed == this.guestSelector.childBedTypes["crib"].value)
            selected = true;
        }
        if (child.Age >= 3) {
          types.push(this.guestSelector.childBedTypes["extra-bed"]);
          if (child.Bed == this.guestSelector.childBedTypes["extra-bed"].value)
            selected = true;
        }
        child.availableBedTypes = types;
        if (!selected && child.Age > -1) {
          child.Bed = child.Age > 5 && types.length > 1 ? types[1].value : types[0].value;
        }
      });
    });
  }

  toggleGuestsSelector(state?: string, e?: any): void {
    if (!state) {
      state = this.isOpen ? "close" : "open";
    }
    if (this.isOpen && state != "open") {
      this.validateGuestInfo();
      this.validated = true;
    }
    if (state == "open" && !this.isOpen) {
      this.isOpen = true;
      this.addCloseListners();
    } else if (state == "close") {
      if (!this.valid) {
        const invalidElem = <any>document.querySelector(".child-age-invalid");
        invalidElem.focus();
        return;
      }
      const isCloseElem = e && e.target ? e.target.classList.contains("close-guest-selector") : null;
      if (isCloseElem || (e && e.target && e.target.parentElement.classList.contains("close-guest-selector"))) {
        if (window.innerWidth > 767) {
          let nextElem = <any>document.querySelector(".booking-widget-options-toggle .visible-medium-up-flex");
          if (nextElem.getAttribute("tabindex") == "-1")
            nextElem = <any>document.querySelector(".booking-widget__submit button");

          nextElem.focus();
        }
      }

      this.isOpen = false;
      this.removeCloseListners();
    }
  }

  _focusOutListner(e: any): void {
    if (e)
      e.preventDefault();
    if (!this.rootEle.contains(e.target))
        this.closeGS(e);
  };

  addCloseListners(): void {
    this.closeEventListner = this._focusOutListner.bind(this);
    document.addEventListener("click",  this.closeEventListner, false);
    document.addEventListener("keyup",  this.closeEventListner, false);
    if (document.querySelector("main.l-section"))
      document.querySelector("main.l-section")["style"].overflow = "visible";
  }

  removeCloseListners(): void {
    document.removeEventListener("click",  this.closeEventListner, false);
    document.removeEventListener("keyup",  this.closeEventListner, false);
    if (document.querySelector("main.l-section"))
      document.querySelector("main.l-section").removeAttribute("style");
  }

  public saveSearchData(): void {
    this.bookingService.saveSearchData(this.guestData, "guest");
  }

  validateGuestInfo(): void {
    let valid = true;
    let invalidElemIndex = -1, invalidRoomIndex = -1;
    this.guestData.rooms.forEach((room, index1) => {
      if (room.Child.length) {
        room.Child.forEach((child, index2) => {
          // @ts-ignore
          if (child.Age < 0) {
            valid = false;
            child.valid = false;
            invalidRoomIndex = invalidRoomIndex != -1 ? invalidRoomIndex : index1;
            invalidElemIndex = invalidElemIndex != -1 ? invalidElemIndex : index2;
          }
        });
      }
    });
    this.valid = valid;
    if ((this.redemption || this.voucher) && this.roomCount > 1) {
      valid = false;
    }
    this.changed.emit({ valid: valid, roomCount: this.roomCount });
    if (document.querySelector(".child-age-invalid"))
      document.querySelector(".child-age-invalid").classList.remove("child-age-invalid");
    if (invalidRoomIndex != -1 && document.getElementById("room["+invalidRoomIndex+"].child["+invalidElemIndex+"].age"))
      document.getElementById("room["+invalidRoomIndex+"].child["+invalidElemIndex+"].age").classList.add("child-age-invalid");
  }

  onEnter(e: KeyboardEvent): void {
    if (e.code && e['which'] == 13) {
      e.preventDefault();
      this.toggleGuestsSelector();
    }
  }

  closeGS(e: any): void {
    this.toggleGuestsSelector('close');
  }
}
